import React from 'react';
import classnames from 'classnames';
import { Section } from '@fiverr-private/fit';
import { Container } from '@fiverr-private/layout_components';
import AssetsVerifier from '../../AssetsVerifier';
import { ProOrientedSearchModal } from '../../ProOrientedSearchModal';
import Header from '../Header';
import styles from './index.module.scss';

const BusinessLayout = ({ children }) => (
    <Section className={classnames(styles.main, 'listings-perseus')}>
        <Header />
        <Container alignItems={'flexStart'} display={'flex'} marginTop={{ default: '12', lg: '4' }}>
            {children}
        </Container>
        <AssetsVerifier />
        <ProOrientedSearchModal />
    </Section>
);

export default BusinessLayout;
